import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioAccommodationEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioAccommodationEntity
